<div class="content">
  @if (
    (appState | async) !== APP_STATE_ENUM.SEARCH &&
    (appState | async) !== APP_STATE_ENUM.ERROR &&
    (shopResultsPageItems | async)
  ) {
    <div class="column twelve float-right lg-eight">
      <drp-results-map
        [searchContext]="searchContext"
        [appState]="appState | async"
        [shopSearchResults]="shopResultsPageItems | async"
        [searchedValue]="searchedValue | async"
        [searchType]="searchType | async"
        [lastSuccessfulSearchedValue]="lastSuccessfulSearchedValue | async"
        [currentMapRedrawTriggerState]="currentMapRedrawTriggerState | async"
        [selectedShop]="selectedShop | async"
        (userRelocatedZipCode)="updateFormZipCode($event)"
        (setMapShopSelection)="setShopSelection($event)"
        (setStateFromResults)="setAppState($event)"
        (searchMarkerCoords)="searchWithNewCoordinates($event)"
        (setMapRedrawTriggerState)="handleMapEvent($event)"
        (setLastSuccessfulSearchedValue)="setLastSuccessfulSearchedValue($event)"
        (shopSelected)="shopSelected.emit($event)"
      >
      </drp-results-map>
    </div>
  }

  <div
    id="search-by"
    class="column twelve lg-four lg-pad-right-20"
    [ngClass]="{ 'lg-pad-top-0': (searchType | async) === SEARCH_TYPES.COORDINATES }"
  >
    <drp-search-wrapper></drp-search-wrapper>
    @if (
      (appState | async) === APP_STATE_ENUM.RESULTS_FOUND &&
      !(searching | async) &&
      (shopSearchResults | async)
    ) {
      <drp-results-wrapper
        [shopSearchResults]="shopSearchResults | async"
        [selectedShop]="selectedShop | async"
        [isPartner]="isPartner"
        (initialize)="initializePagination($event)"
        (setCurrentPage)="setCurrentPage($event)"
        (selectedCard)="setShopSelection($event)"
        (mapEvent)="handleMapEvent($event)"
      ></drp-results-wrapper>
    }
    <ds-localized-spinner
      class="block pad-bottom-20"
      [dataLoading]="searching | async"
      [loadingMessage]="'Looking for nearby shops'"
    >
    </ds-localized-spinner>
    @if (
      !(searching | async) &&
      ((appState | async) === APP_STATE_ENUM.RESULTS_NOT_FOUND ||
        (appState | async) === APP_STATE_ENUM.ERROR ||
        (appState | async) === APP_STATE_ENUM.NO_MAP_RESULTS)
    ) {
      <drp-no-results-card [searchContext]="searchContext" (cancel)="cancel.emit()">
      </drp-no-results-card>
    }
  </div>

  @if (
    ((appState | async) === APP_STATE_ENUM.SEARCH || (appState | async) === APP_STATE_ENUM.ERROR) &&
    searchContext != SEARCH_CONTEXT.RENTAL_SELECTION
  ) {
    <div class="column twelve md-pad-left-20 md-pad-right-20 md-four right content-top self-center">
      <span>
        Our<span style="font-weight: 700">
          {{
            isPartner ? 'Value in Partnership (VIP) Program' : 'Dreams Restored Program (DRP)'
          }}</span
        >
        takes the stress out of choosing a repair shop. Search for and connect with a trusted,
        customer-friendly shop near you.
      </span>
    </div>
  }

  @if (
    (appState | async) === APP_STATE_ENUM.SEARCH || (appState | async) === APP_STATE_ENUM.ERROR
  ) {
    <div
      class="column twelve md-pad-right-20 md-pad-left-20 md-four right sm-pad-bottom-20 self-center"
    >
      <span class="icon-call text-right"></span>
      <span class="md-pad-left-10">
        Need to contact our customer care team? Call us at
        @if (isPartner) {
          <a
            dsPartnerContent
            [brandHref]="'selectClaimPhoneNumFullHref'"
            [brandContent]="'selectPrettyClaimPhoneNum'"
          ></a>
        } @else {
          <a dsContent [contentPath]="'shared.amfamPhoneNumber'" [href]="amfamPhone"></a>
        }
      </span>
    </div>
  }
</div>
